import { render, staticRenderFns } from "./PersonCenter.vue?vue&type=template&id=0d95c5ae&scoped=true&"
import script from "./PersonCenter.vue?vue&type=script&lang=js&"
export * from "./PersonCenter.vue?vue&type=script&lang=js&"
import style0 from "./PersonCenter.vue?vue&type=style&index=0&id=0d95c5ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d95c5ae",
  null
  
)

component.options.__file = "PersonCenter.vue"
export default component.exports